<template>
  <div class="l-learn-voice-test l-learn-content-w-container" v-if="element">
    <div class="l-learn-voice-mask" @click="onHandPlay" v-if="audio.isShowPlay"></div>
    <!-- 题干图片 -->
    <div class="l-learn-question-stem-all">
      <div class="l-learn-question-stem">
        <LImage :url="currentTestItem.realQuestionImageUrl" :isScroll="false" />
        <LNumber :current="currentCount" :total="element.totalCount" class="l-learn-number" />
        <LReplay :play="audio.isPlay" :repeatNumber="element.attrs.repeatQuestionNum - element.repeat"
          :notAllowed="recordStatus != 1 || audio.isPlay" @replay="onReplay" class="l-learn-replay" />
      </div>
    </div>
    <!-- 答题-录音 -->
    <div class="lSoundRecording-btn">
      <lRecorder ref="recorder" :disabled="recordStatus == 0" :options="recorderOptions" :allow-manual="true"
        @result="onresult" @init="onRecordInit" />
    </div>
  </div>
</template>

<script>
import version from '@/utils/version'
import laudio from '@/utils/laudio'
import { lLoading } from '@/components/l-loading'
import LImage from '../../components/l-image'
import LNumber from '../../components/l-number'
import LReplay from '../../components/l-replay'
import lRecorder from '../../components/l-recorder'
import IMGUpModel from '@/models/imgup'
import localKeyLock from '@/utils/localKeyLock'
import { createNamespacedHelpers } from 'vuex'
import { sleep } from '../../../../utils/util'
import { recordStudyPlayData } from '@/utils/record'

const courseMapGetters = createNamespacedHelpers('course').mapGetters
const userMapGetters = createNamespacedHelpers('user').mapGetters
const { mapActions } = createNamespacedHelpers('course')
const imgUp = new IMGUpModel()
const VOICE_TEST = 'VOICE_TEST'
const VOICE_TEST_LAST_KEY = `${VOICE_TEST}_LAST_KEY`

export default {
  name: 'l-learn-voice-test',
  components: { LImage, LNumber, LReplay, lRecorder },
  data() {
    return {
      LOCAL_STAGE_KEY: 'VOICE_TEST',
      LOCAL_RECORD_TIME_KEY: '', // 录音次数本地KEY
      laudio: null,
      recordStatus: 0, // 0,1,2 录音状态
      isPlayClick: false, // 是否点击
      stage: '', // 当前答题阶段
      audioData: '', // 录音数据
      refText: '', // 答案
      keywords: '', // 中心词
      currentTestItem: {},
      STAGE_TYPES: {
        isAudioExplain: 'AUDIO_EXPLAIN', // 题干
        isRecording: 'RECORDING', // 录音
        isPlayAnswer: 'ANSWER_AUDIO', // 播放答案音频
      },
      audio: {
        autoplay: true, // 自动播放
        isShowPlay: false, // 播放按钮
        isPlay: false, // 是否播放中
      },
      recorderOptions: {}, // 录音配置参数
      playTimer: null,
      playTime: 0, // 进入页面开始播放的播放时长
    }
  },
  computed: {
    ...courseMapGetters(['element', 'highWord']),
    ...userMapGetters(['user']),
    currentCount() {
      return this.element.datas.length - this.element.unansweredList.length + 1
    }
  },
  watch: {
    async 'element.ELEMENT_TYPE'(to) {
      if (to) {
        this.currentTestItem = this.element.unansweredList[0]
        if (this._isDone()) {
          this._next()
          return
        }
        if (this.currentTestItem) {
          this._initSourceUrl()
          // 录音参数
          this.recorderOptions.elementType = this.element.type
          this.recorderOptions.text = (
            await this._getText(this.currentTestItem.attrs.answerTxt)
          ).data[0]
          this.recorderOptions.keywords = (
            await this._getText(this.currentTestItem.attrs.keywordTxt)
          ).data[0]

          this.recorderOptions.duration = this.element.attrs.answerRecordTime
          this.recorderOptions.audioFileName = `${this.element.RECORD_ID}-${this.currentTestItem.id}`
        } else {
          console.log('未获得数据')
        }
      }
    },
    stage() {
      switch (this.stage) {
        case this.STAGE_TYPES.isAudioExplain:
          console.log('题干')
          this.audio.isShowPlay = true
          this._initAudio(true)
          break
        case this.STAGE_TYPES.isRecording:
          console.log('录音')
          this.audio.isShowPlay = false
          if (!this.laudio) {
            this._initAudio(false)
          }
          this.recordStatus = 1
          break
        case this.STAGE_TYPES.isPlayAnswer: {
          console.log('播放答案')
          // 第一次回答已经播放过答案，所以后续直接提交，不再播放
          const times = this._getRecordTimes()
          if (times >= 1) {
            this._submit()
            break
          }
          this.audioData = this._getLocalStage()
            ? this._getLocalStage().data
            : null
          this.audio.isShowPlay = true
          this._initAudio(
            true,
            this.audioData.suggestedScore >= 43
              ? this.currentTestItem.realRightAudioUrl
              : this.currentTestItem.realWrongAudioUrl
          )
          break
        }
      }
    },
  },
  methods: {
    ...mapActions(['STUDY_RESULT', 'STUDY_MEDIA_REPEAT']),
    _getRecordTimes() {
      const v = localStorage.getItem(this.LOCAL_RECORD_TIME_KEY)
      const n = Number(v)
      return Number.isFinite(n) && n > 0 ? n : 0
    },
    _setRecordTimes(times) {
      localStorage.setItem(this.LOCAL_RECORD_TIME_KEY, String(times))
    },
    _clearRecordTimes() {
      localStorage.removeItem(this.LOCAL_RECORD_TIME_KEY)
    },
    // 录音初始化成功
    onRecordInit() {
      // 提示带耳机，并主动触发开始
      this.$refs.recorder.start()
      this._countTime()
    },
    // 录音完成
    onresult(data) {
      this.audioData = data

      if (this.audioData) {
        this.audioData.suggestedScore = this.audioData.suggestedScore
          ? this.audioData.suggestedScore
          : 1
        // this._submit()
        this._localStage({
          stage: this.STAGE_TYPES.isPlayAnswer,
          data: this.audioData,
        })

        recordStudyPlayData({
          id: this.currentTestItem.id,
          bizType: this.element.type,
          type: 1,
          offset: this.playTime,
        }, this.element.ELEMENT_TYPE)
      }
    },

    // 获取资源全路径
    _initSourceUrl() {
      imgUp
        .resource({
          paths: [
            this.currentTestItem.attrs.questionImageUrl,
            this.currentTestItem.attrs.rightAudioUrl,
            this.currentTestItem.attrs.wrongAudioUrl,
            this.currentTestItem.attrs.questionAudioUrl,
          ],
        })
        .then((res) => {
          this.$set(this.currentTestItem, 'realQuestionImageUrl', res.data[0])
          this.$set(this.currentTestItem, 'realRightAudioUrl', res.data[1])
          this.$set(this.currentTestItem, 'realWrongAudioUrl', res.data[2])
          this.$set(this.currentTestItem, 'realQuestionAudioUrl', res.data[3])
          this._initStage()
        })
        .catch((err) => {
          this.$lPrompt({
            message: err.msg,
            successTxt: this.$locale.确定,
          })
          this._initStage()
        })
    },
    //根据关键词修改
    _getText(text) {
      return imgUp.getContent({
        paths: [text],
      })
    },
    //根据缓存初始化当前元素的闯关进度
    _initStage() {
      // 当前学习元素+当前学生记录+当前题目
      const currentValueKey = `${this.LOCAL_STAGE_KEY}_${this.element.RECORD_ID}_${this.currentTestItem.id}`
      const localKey = VOICE_TEST_LAST_KEY
      this.LOCAL_STAGE_KEY = localKeyLock(localKey, currentValueKey)
      this.LOCAL_RECORD_TIME_KEY = `${this.LOCAL_STAGE_KEY}_TIME`

      try {
        const currentRecord = this._getLocalStage()
        // 初始化stage数据，什么都没有，则为题干讲解状态
        this.stage =
          currentRecord && currentRecord.stage
            ? currentRecord.stage
            : this.STAGE_TYPES.isAudioExplain
      } catch (error) {
        // 报错，默认什么都没有，则为初始化状态
        this._localStage({ stage: this.STAGE_TYPES.isAudioExplain })
        this.audio.isShowPlay = true
        this._initAudio()
      }
    },
    // 初始化音频
    _initAudio(autoplay, src) {
      this.laudio = laudio({
        autoplay: autoplay == false ? false : this.audio.autoplay,
        src: src || this.currentTestItem.realQuestionAudioUrl,
      })
      if (this.laudio) {
        this._initEvent()
      }
    },
    // 监听事件
    _initEvent() {
      // 监听播放事件
      this.laudio.addEventListener('play', () => {
        this.audio.isShowPlay = false
        this.audio.isPlay = true
        this.recordStatus = 0
        console.log('音频播放', this.stage)
      })

      // 监听暂停事件
      this.laudio.addEventListener('pause', () => {
        this.audio.isPlay = false
        console.log('音频暂停')
      })

      // 播放完成
      this.laudio.addEventListener('ended', () => {
        console.log('播放完成', this.stage)
        if (this.stage === this.STAGE_TYPES.isAudioExplain) {
          this._localStage({ stage: this.STAGE_TYPES.isRecording })
          this.recordStatus = 1
          this.audio.isPlay = false
          // ios系统在手动触发题干音的情况下，题干音播放完刷新页面
          if (this.isPlayClick) {
            console.log('题干播放完成刷新')
            this.isPlayClick = false
            location.reload()
          }
        } else if (this.stage === this.STAGE_TYPES.isPlayAnswer) {
          console.log('提交')
          this._submit()
        } else if (this.stage === this.STAGE_TYPES.isRecording) {
          this.recordStatus = 1
          this.audio.isPlay = false
        }
      })
    },
    // 下一节点
    _next() {
      this.$emit('next')
    },
    // 手动触发播放
    async onHandPlay() {
      if (version.isIOS() && version.isLILYTribeAPP()) {
        lLoading.show()
        await sleep(1)
        lLoading.hide()
      }
      this.laudio.play()
      if (this.stage == this.STAGE_TYPES.isAudioExplain && !version.isPC()) {
        console.log('自动播放失败，设置手动点击播放状态')
        this.isPlayClick = true
      }
    },
    // 缓存当前学习进度，防止刷新丢失
    _localStage(params) {
      if (params) {
        this.stage = params.stage
        localStorage.setItem(this.LOCAL_STAGE_KEY, JSON.stringify(params))
      } else {
        localStorage.removeItem(this.LOCAL_STAGE_KEY)
      }
    },
    _getLocalStage() {
      let currentRecord = localStorage.getItem(this.LOCAL_STAGE_KEY)

      if (currentRecord) {
        currentRecord = JSON.parse(currentRecord)
      }

      return currentRecord
    },
    _isDone() {
      return this.currentCount > this.element.totalCount
    },
    _retryCurrentQuestion() {
      // 只重置本题状态，不刷新页面（避免提交记录后刷新直接跳下一题）
      if (this.laudio) {
        try {
          this.laudio.pause()
        } catch (e) {
          /* noop */
        }
      }
      this.audio.isPlay = false
      this.audio.isShowPlay = false
      this.audioData = null

      // 切回录音阶段并放开录音按钮
      this._localStage({ stage: this.STAGE_TYPES.isRecording })
      this.recordStatus = 1

      // 重置录音组件状态（让按钮可重新录音）
      if (this.$refs.recorder && typeof this.$refs.recorder.reset === 'function') {
        this.$refs.recorder.reset()
      }
    },
    // 提交答案
    _submit() {
      // 提交答题
      if (this.audioData && this.audioData.suggestedScore) {
        this.STUDY_RESULT({
          elementId: this.element.id,
          postData: {
            eleId: this.currentTestItem.id,
            ...this.audioData,
          },
        })
          .then((res) => {
            const record = res && res.records && res.records[res.records.length - 1]
            const word = record && record.word ? String(record.word).toLowerCase() : ''
            const times = this._getRecordTimes() + 1
            this._setRecordTimes(times)
            // 第一次作答且评价为 poor 或 average：留在本题重做一次；第二次不管评价如何都进入下一题
            if ((word === 'poor' || word === 'average') && times === 1) {
              this.$lPrompt({
                message: `Try Again!`,
                successTxt: 'OK',
                successFn: () => {
                  // 重做：保留作答次数，重置按钮状态
                  this._retryCurrentQuestion()
                },
              })
              return
            }

            // 进入下一题：清理本题作答次数与进度
            this._clearRecordTimes()
            localStorage.removeItem(this.LOCAL_STAGE_KEY)
            if (this._isDone()) {
              this._next()
              return
            }
            location.reload()
          })
          .catch(() => {
            this.$lPrompt({
              message: `提交失败，请刷新后重试`,
              successTxt: '好的',
              successFn: () => {
                location.reload()
              },
            })
          })
      } else {
        this.$lPrompt({
          message: `因为意外情况，数据有误，重新开始当前题`,
          successTxt: '重新开始',
          successFn: () => {
            localStorage.removeItem(this.LOCAL_STAGE_KEY)
            this._clearRecordTimes()
            location.reload()
          },
        })
      }
    },
    // 重播题干
    async onReplay() {
      if (
        this.laudio &&
        this.element.attrs.repeatQuestionNum - this.element.repeat > 0 &&
        this.recordStatus !== 3 && this.$refs.recorder.status != 2
      ) {
        this.laudio.play()

        await this.STUDY_MEDIA_REPEAT({
          elementId: this.element.id,
        })
      }
    },
    // 播放计时
    _countTime() {
      this.playTimer = setInterval(() => {
        this.playTime += 1
      }, 1000)
    },
  },
  destroyed() {
    if (this.laudio) {
      this.laudio.pause()
    }
    if (this.playTimer) {
      clearInterval(this.playTimer)
    }
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
